import { useEffect, useState } from 'react'

import { useDataCatalogSelector } from 'modules/ai_reports/components/DataCatalogSelector/useDataCatalogSelector'

import { getSlugFromTableId } from './slug-tableid-mapping'

export const useSlugToSourceId = (slug: string | undefined) => {
  const [sourceId, setSourceId] = useState<string | undefined>(undefined)

  const { datasources, loading, error } = useDataCatalogSelector()

  useEffect(() => {
    if (slug && !loading) {
      const source = datasources?.find((source) => {
        return getSlugFromTableId(source.id) === slug
      })

      if (source) {
        setSourceId(source.id)
      } else {
        throw new Error(`Source ${slug} not found`)
      }
    } else {
      setSourceId(undefined)
    }
  }, [slug, datasources, loading])

  return {
    sourceId,
    loading,
    error,
  }
}
